import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmailSignature from './EmailSignature';
import EmptySpace from '../modules/EmptySpace';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, linkText } from '../../../helpers/getEmailStyles';

class BanStatusServiceStatusBanned extends React.Component {


    render() {
        const { content: { userName, adminMail, logo, siteName } } = this.props;
        let mailTo = 'mailto:' + adminMail;

        return (
            <Layout>
                <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
                <div style={body}>
                    <div style={fontWeightBold}>
                        Bonjour {userName},
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        Nous avons le regret de vous informer que votre compte a été désactivé en raison d'une violation des conditions d'utilisation de notre plateforme. Le maintien d'un environnement sûr et respectueux pour tous les utilisateurs est notre priorité.
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        Si vous avez des questions, n'hésitez pas à contacter notre <a href={mailTo} style={linkText}>équipe de support</a>.
                    </div>
                    <EmptySpace height={20} />
                    <EmailSignature siteName={siteName} />
                </div>
                <EmptySpace height={40} />
                <Footer siteName={siteName} />
                <EmptySpace height={20} />
            </Layout>
        );
    }

}

export default BanStatusServiceStatusBanned;